
import { useState } from   'react';
import { Row, Col, InputGroup, Form, Button } from 'react-bootstrap';
import { FaUsers } from 'react-icons/fa';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useAuth } from '../../Auth/AuthContext';
import apiService from '../../Auth/apiService';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Tooltip } from 'react-tooltip';
import { useForm } from 'react-hook-form';
import * as XLSX from 'xlsx';


export default function ConsultaDX() {
    const { token, user } = useAuth();
    const minDate = new Date(2019, 4, 30);
    const maxDate = new Date(); // Today
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [Cargando, setCargando] = useState(false);
    const [mostrarDetalles, setMostrarDetalles] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [diagnosticos, setDiagnosticos] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const [actoresarmados, setActoresarmados] = useState([]);
    const [lugares , setLugares] = useState({
        barrio: [],
        municipio: [],
        actorArmado: [],
        tipoMovilidad: []
    });
    const [integrantes, setIntegrantes] = useState([]);
    const [lugarExacto, setLugarExacto] = useState([]);
    const [infoModal, setInfoModal] = useState({
        show: false,
        content: {}
    })
    const exportarExcel = () => {
        // Convierte los datos a una hoja de Excel
        const worksheet = XLSX.utils.json_to_sheet(diagnosticos);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Diagnosticos");
        // Descarga el archivo
        XLSX.writeFile(workbook, "diagnosticos.xlsx");
    };
    const exportarCSV = (data) => {
        const diagnosticos = data || [];
        if (!diagnosticos.length) return;
        const replacer = (key, value) => value === null || value === undefined ? '' : value;
        const header = Object.keys(diagnosticos[0]);
        const csv = [
            header.join(','), // header row first
            ...diagnosticos.map(row =>
                header.map(fieldName =>
                    JSON.stringify(row[fieldName], replacer)
                ).join(',')
            ),
        ].join('\r\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'diagnosticos.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const { watch, handleSubmit, register, setValue, reset, control, formState: { errors }} = useForm({ 
            defaultValues: {
                iddx: '',
            } 
        }
        );
    async function ConsultarIntegrantes(id) {
        const url = '/diagnostico/consultarintegrantesdx';
        const obj = {
            idDx: id
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setIntegrantes(response.data.integrantes);
            }
        } catch (error) {
            console.error('Error fetching integrantes:', error);
            Mensaje('Error', 'No se pudieron cargar los integrantes del diagnóstico.', 'error');
        }
    }
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title: title,
            html: text,
            icon: icon,
        });
    };
    const MostrarFormularioDiagnostico = (row) =>  {
        setSelectedRow(row);
        setMostrarDetalles(true);
        ConsultarIntegrantes(row.id);
    };
    const buscarDxsFecha = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxporfecha';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.diagnosticos)
                setLugarExacto(response.data.lugaresexpulsores)
                setBarrios(response.data.barrios)
                setActoresarmados(response.data.actoresarmados)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };    
    const buscarDxsDocumento = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxpordocumento';
        const obj = {
            idPersona: watch('documento')
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.diagnosticos)
                setLugarExacto(response.data.lugaresexpulsores)
                setBarrios(response.data.barrios)
                setActoresarmados(response.data.actoresarmados)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const buscarDxsidentificacion = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarreporteidentificacion';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.identificaciones)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const buscarDxsextranjeros = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarreporteextranjeros';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {   
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.extranjeros)
                setLugarExacto(response.data.lugaresexpulsores)
                setBarrios(response.data.barrios)
                setActoresarmados(response.data.actoresarmados)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const buscarDxsjuridicos = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarreportejuridico';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.juridico)
                setLugarExacto(response.data.lugaresexpulsores)
                setBarrios(response.data.barrios)
                setActoresarmados(response.data.actoresarmados)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const buscarDXProteccionBienes = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarreporteproteccionbienes';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.bienes)
                setLugarExacto(response.data.lugaresexpulsores)
                setBarrios(response.data.barrios)
                setActoresarmados(response.data.actoresarmados)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const ConsultarDXPsicosocial = async (iddx) => {
        setCargando(true);
        const url = '/diagnostico/consultarreportepsicosocial';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null,
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.psicosocial);
                setLugarExacto(response.data.lugaresexpulsores);
                setBarrios(response.data.barrios);
                setActoresarmados(response.data.actoresarmados);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };

    const buscarmisDx = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxporusuario';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null,
            usrid: user,
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.diagnosticos)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const ConsultarDXReunificacion = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarreportereunificacion';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.reunificacion);
                setLugarExacto(response.data.lugaresexpulsores);
                setBarrios(response.data.barrios);
                setActoresarmados(response.data.actoresarmados);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    const ConsultarDXRiesgoVida = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarreporteriesgovida';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.riesgo);
                setLugarExacto(response.data.lugaresexpulsores);
                setBarrios(response.data.barrios);
                setActoresarmados(response.data.actoresarmados);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    const ConsultaVisitas = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarreportevistas';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.visitas);
                setLugarExacto(response.data.lugaresexpulsores);
                setBarrios(response.data.barrios);
                setActoresarmados(response.data.actoresarmados);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    const consultarDXbase = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxbase';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'diagnostico_base.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    const ConsultarDXporFechaHecho = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxporfechahecho';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'diagnostico_base.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    const consultarIntegrantesDx = async () => {
        setCargando(true);
        const url = '/diagnostico/consultarintegrantesdxbase';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'diagnostico_integrantes_base.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching integrantes:', error);
            Mensaje('Error', 'No se pudieron cargar los integrantes del diagnóstico.', 'error');
        } finally {
            setCargando(false);
        }
    }
    const ConsultarDXconIntegrantes = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxconintegrantes';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                exportarCSV(response.data.resultados);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
             <SeccionPageHeader
            title="Diagn&oacute;stico base - consulta de diagn&oacute;stico"
            idCabezaFamilia="1"
            url="/dx/diagnosticodx"
            nombreurl="Diagnostico dx"
            nombreform="consulta de diagnostico"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
            <div id="formDiagnostico" className="card">
                
                <div className="row">
                <div className="col-md-12">
                <div className="tab-content">
                    <div className="card mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">Consulta de diagnosticos</h5>
                    </div>
                    <div className='row mb-3'>
                        <div className='col-md-4'>
                        <div className="card-body">
                            <h5 className="mb-12">Por documento</h5>
                            <Row className="mb-12" style={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
                            <Col md={12}>
                                <Form.Control
                                type="text"
                                placeholder="Número de documento"
                                {...register('documento')}
                                autoComplete="off"
                                />
                            </Col>
                            </Row>
                            <Row className="mb-3">
                            <Col md={12}>
                                <Button variant="primary" onClick={buscarDxsDocumento}>
                                Buscar
                                </Button>
                            </Col>
                            </Row>
                        </div>
                        </div>
                        <div className='col-md-8'>
                        <div className="card-body">
                            <h5 className="mb-12">Por fechas</h5>
                            <Row className="mb-12" style={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
                            <Col md={6}>
                                <InputGroup>
                                <InputGroup.Text>Fecha inicio</InputGroup.Text>
                                <DatePicker
                                    selected={fechaInicio}
                                    onChange={date => setFechaInicio(date)}
                                    minDate={minDate}
                                    maxDate={fechaFin || maxDate}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    placeholderText="Seleccione fecha inicio"
                                />
                                </InputGroup>
                            </Col>
                            <Col md={6}>
                                <InputGroup>
                                <InputGroup.Text>Fecha fin</InputGroup.Text>
                                <DatePicker
                                    selected={fechaFin}
                                    onChange={date => setFechaFin(date)}
                                    minDate={fechaInicio || minDate}
                                    maxDate={maxDate}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    placeholderText="Seleccione fecha fin"
                                />
                                </InputGroup>
                            </Col>
                            </Row>
                            <Row className="mb-3">
                            <Col>
                                <Button variant="primary" onClick={buscarDxsFecha} className="mb-2 me-2">
                                    Buscar todos DX
                                </Button>
                                <Button variant="primary" onClick={buscarDxsidentificacion} className="mb-2 me-2">
                                    Registraduria
                                </Button>
                                <Button variant="primary" onClick={buscarDxsextranjeros} className="mb-2 me-2">
                                    Extranjeros
                                </Button>
                                <Button variant="primary" onClick={buscarDxsjuridicos} className="mb-2 me-2">
                                    Juridicos
                                </Button>
                                <Button variant="primary" onClick={buscarDXProteccionBienes} className="mb-2 me-2">
                                    Protecci&oacute;n bienes
                                </Button>
                                <Button variant="primary" onClick={() => ConsultarDXPsicosocial()} className="mb-2 me-2">
                                    Psicosocial
                                </Button>
                                <Button variant="primary" onClick={() => ConsultarDXReunificacion()} className="mb-2 me-2">
                                    Reunificaci&oacute;n
                                </Button>
                                <Button variant="primary" onClick={() => ConsultarDXRiesgoVida()} className="mb-2 me-2">
                                    Riesgo vida
                                </Button>
                                <Button variant="primary" onClick={() => ConsultaVisitas()} className="mb-2 me-2">
                                    Visitas domiciliarias
                                </Button>
                                <Button variant="primary" onClick={() => buscarmisDx()} className="mb-2 me-2">
                                    Mis diagnosticos
                                </Button>
                                <Button variant="success" onClick={() => consultarDXbase()} className="mb-2 me-2">
                                    Exportar diagnostico base   
                                </Button>
                                <Button variant="success" onClick={() => consultarIntegrantesDx()} className="mb-2 me-2">
                                    Exportar integrantes base
                                </Button>
                                <Button variant="success" onClick={() => ConsultarDXconIntegrantes()} className="mb-2 me-2">
                                    Exportar DX con integrantes
                                </Button>
                                <Button variant="success" onClick={() => ConsultarDXporFechaHecho()} className="mb-2 me-2">
                                    Diagn&oacute;stico por fecha hecho
                                </Button>
                            </Col>
                            </Row>
                        </div>
                        </div>
                    </div>
                    <div className='card-body'>
                        <Button variant="success" onClick={exportarExcel} className="mb-2">
                        Exportar Excel
                        </Button>
                        <div style={{ overflowX: 'auto' }}>
                            <table className="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th>Acciones</th>
                                        <th>Id</th>
                                        <th>Fecha</th>
                                        <th>Primer Nombre</th>
                                        <th>Segundo Nombre</th>
                                        <th>Primer Apellido</th>
                                        <th>Segundo Apellido</th>
                                        <th>Documento</th>
                                        <th>Responsable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {diagnosticos.length === 0 ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No hay diagnosticos para mostrar
                                            </td>
                                        </tr>
                                    ) : (
                                        diagnosticos.map((row, idx) => (
                                            <tr key={row.id || idx}>
                                                <td>
                                                    <button
                                                        type="button"
                                                        onClick={() => MostrarFormularioDiagnostico(row)}
                                                        style={{
                                                            backgroundColor: 'skyblue',
                                                            padding: '12px 20px',
                                                            fontSize: '1.5rem',
                                                            borderRadius: '8px',
                                                            border: 'none',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: 'black'
                                                        }}
                                                        data-tooltip-id='tooltiparriba'
                                                        data-tooltip-content="Ver diagnostico"
                                                    >
                                                        <FaUsers />
                                                    </button>
                                                </td>
                                                <td>{row.id}</td>
                                                <td>{row.dxFecha || row.dxfecha}</td>
                                                <td>{row.id111PNombre}</td>
                                                <td>{row.id112SNombre}</td>
                                                <td>{row.id113PApellido}</td>
                                                <td>{row.id114SApellido}</td>
                                                <td>{row.id122NDocumento}</td>
                                                <td>{row.dx71NombreResponsableAtencion}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>                                
                    </div>
                    {mostrarDetalles && selectedRow && <div className="card mb-4">
                    <div className="card-header">
                        <div className="d-flex align-items-center mb-2">
                        <h5 className="mb-0 me-3">Datos detallados</h5>
                        </div>
                    </div>
                    <div className='card-body'>
                        <Row>
                        <Col md={3}>
                            <Form.Label>Id: {selectedRow.id || ''}</Form.Label> 
                            <p><strong>Fecha diagn&oacute;stico: </strong> {selectedRow.dxFecha?.split('T')[0] ?? selectedRow.dxFecha}</p>
                        </Col>
                        <Col md={3}>
                            <Form.Label>Nombres</Form.Label>
                            <p>{selectedRow.id111PNombre || ''} {selectedRow.id112SNombre || ''} {selectedRow.id113PApellido || ''} {selectedRow.id114SApellido || ''}</p>
                        </Col>
                        <Col md={2}>
                            <Form.Label>Documento</Form.Label>
                            <p>{selectedRow.id122NDocumento || ''}</p>
                        </Col>
                        <Col md={2}>
                            <Form.Label>Sexo</Form.Label>
                            <p>{selectedRow.id21Sexo === 1 ? 'Masculino' : selectedRow.id21Sexo === 2 ? 'Femenino' : ''}</p>
                        </Col>
                        <Col md={2}>
                            <Form.Label>Fecha Nacimiento Edad</Form.Label>
                            <p>{selectedRow.dif221FNacimiento ? new Date(selectedRow.dif221FNacimiento).toLocaleDateString() : ''}-{selectedRow.dif222Edad || ''}</p>
                        </Col>
                        </Row>
                        <Row>
                        <Col md={2}>
                            <Form.Label>Direcci&oacute;n</Form.Label>
                            <p>{selectedRow.ubi34Direccion || ''}</p>
                        </Col>
                        <Col md={2}>
                            <Form.Label>Tel&eacute;fonos</Form.Label>
                            <p>{selectedRow.ubi35Telefonos || ''} {selectedRow.ubi352Telefono || ''}</p>
                        </Col>
                        <Col md={3}>
                            <Form.Label>Comuna/Corregimiento Barrio/Vereda Asentamiento/Sector</Form.Label>
                            <p>{barrios.find( 
                            barrio => barrio.id === selectedRow.ubi32BarrioOVereda?.toString()
                            )?.comuna || ''} - {barrios.find( 
                            barrio => barrio.id === selectedRow.ubi32BarrioOVereda?.toString()
                            )?.barrio || ''} - {selectedRow.ubi33AsentamientoOSector || ''}</p>
                        </Col>
                        </Row>
                        <Row>
                        <Col md={2}>
                            <Form.Label>¿Aplica entrega?</Form.Label>
                            <p>{selectedRow.res621AplicaEntrega === 1 ? 'Sí' : selectedRow.res621AplicaEntrega === 2 ? 'No' : ''}</p>
                        </Col>
                        <Col md={1}>
                            <Form.Label>Temporalidad</Form.Label>
                            <p>{selectedRow.res622Temporalidad || ''}</p>
                        </Col>
                        <Col md={1}>
                            <Form.Label>Alimentos</Form.Label>
                            <p>{selectedRow.res623Alimentos || ''}</p>
                        </Col>
                        <Col md={1}>
                            <Form.Label>Kits</Form.Label>
                            <p>{selectedRow.res624Kits || ''}</p>
                        </Col>
                        <Col md={2}>
                            <Form.Label>Alimentos Efectivo</Form.Label>
                            <p>{selectedRow.res625AlimentosEfectivo || ''}</p>
                        </Col>
                        <Col md={1}>
                            <Form.Label>Subs. Temporalidad</Form.Label>
                            <p>{selectedRow.res626SubsidiariedadTemporalidad || ''}</p>
                        </Col>
                        <Col md={2}>
                            <Form.Label>Subs. Alimentos</Form.Label>
                            <p>{selectedRow.res627SubsidiariedadAlimentos || ''}</p>
                        </Col>
                        <Col md={1}>
                            <Form.Label>Subs. Kits</Form.Label>
                            <p>{selectedRow.res628SubsidiariedadKits || ''}</p>
                        </Col>
                        <Col md={1}>
                            <Form.Label>Albergue</Form.Label>
                            <p>{selectedRow.res629Albergue || ''}</p>
                        </Col>
                        </Row>
                        <Row>
                        <Col md={4}>
                            <Form.Label>Si/No Aplica - Indicar Motivo</Form.Label>
                            <p>{selectedRow.res6211SiNoAplicaIndicarMotivo || ''}</p>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Observaciones resultado</Form.Label>
                            <p>{selectedRow.res61Observacionesatencion || ''}</p>
                        </Col>
                        </Row>
                        <Row>
                        <Col md={12}>
                            <Form.Label>Observaciones de la v&iacute;ctima</Form.Label>
                            <p>{selectedRow.vict47Observaciones || ''}</p>
                        </Col>
                        </Row>
                        {integrantes.length > 0 && (
                        <Row>
                            <Col md={12}>
                            <Form.Label>Integrantes</Form.Label>
                            <div style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                    <th>Nombre</th>
                                    <th>Documento</th>
                                    <th>Parentesco</th>
                                    <th>Edad</th>
                                    <th>Esta en Medellin</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {integrantes.map((integrante) => (
                                    <tr key={integrante.id || ''}>
                                        <td>
                                        {integrante.pnombre || ''} {integrante.snombre || ''} {integrante.papellido || ''} {integrante.sapellido || ''}
                                        </td>
                                        <td>{integrante.numdoc || ''}</td>
                                        <td>{integrante.par_parentesco || ''}</td>
                                        <td>{integrante.edad || ''}</td>
                                        <td>{integrante.noestaenmedellin ? 'NO' : 'SI'}</td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                            </div>
                            </Col>
                        </Row>
                        )}
                    </div>
                    </div>}
                </div>
                </div>
                </div>
            </div>    
            <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
        
        )
  }